import React from "react";
import { useSmoothScroll } from "../../hooks/useSmoothScroll";
import { NavbarCTA } from "./NavbarCTA";
import { NavLink } from "./NavbarConfig";

interface NavbarMobileProps {
  isOpen?: boolean;
  links?: NavLink[];
  ctaLabel?: string;
  ctaHref?: string;
  activeSection?: string;
  onLinkClick?: () => void;
}

export function NavbarMobile({ 
  isOpen = false, 
  links = [], 
  ctaLabel = "Fale Comigo", 
  ctaHref = "#contato", 
  activeSection = "", 
  onLinkClick = () => {} 
}: NavbarMobileProps) {
  const smoothScroll = useSmoothScroll();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    smoothScroll(e, href, onLinkClick);
  };

  return (
    <div
      className={`nav__mobile ${isOpen ? "nav__mobile--aberto" : ""}`}
      aria-hidden={!isOpen}
    >
      {links.map((link) => {
        const linkId = link.href.replace("#", "");
        const isActive = activeSection === linkId;
        
        return (
          <a
            key={link.href}
            className={`nav__mobile-link ${isActive ? "nav__mobile-link--active" : ""}`}
            href={link.href}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleLinkClick(e, link.href)}
          >
            {link.label}
          </a>
        );
      })}
      <NavbarCTA
        label={ctaLabel}
        href={ctaHref}
        className="nav__mobile-cta"
      />
    </div>
  );
}